(function() {

	"use strict"

	angular
		.module( "ATMGurus" )
		.service( "Loader", LoaderService)

	LoaderService.$inject = ["$timeout"];

	function LoaderService($timeout) {

		var visible = false;

		var service = {
			visbile: visible,
			isVisible: isVisible,
			show: show,
			hide: hide
		}

		return service;

		////////////////////	METHODS

		function isVisible() {
			return visible;
		}

		function show() {
			visible = true;
		}

		function hide() {
			setTimeout(function() {
				visible = false;
			}, 200);
		}

	}
})()


// WEBPACK FOOTER //
// ./src/app/services/LoadingService.js